import clsx from 'clsx';
import { useState } from 'react';

import * as styles from './Button.module.css';
import { TrackedButton } from '@objectiv/tracker-react';

type ButtonProps = {
  children?: React.ReactNode;
  className?: string;
  animateOnHover?: boolean;
  element?: JSX.Element;
  trackingId?: string;
};

const getContent = (children: React.ReactNode, animateOnHover: boolean) => {
  if (typeof children === 'string' && animateOnHover) {
    return children.split(' ').map((word, index, arr) => (
      <span
        key={index}
        className={styles.word}
        style={
          {
            '--total': arr.length - 1,
            '--index': index,
          } as React.CSSProperties
        }
      >
        {word}
        {'\u00A0'}
      </span>
    ));
  }

  return children;
};

export const Button: React.FC<ButtonProps> = ({
  children,
  className,
  animateOnHover = true,
  trackingId,
  element = <TrackedButton objectiv={{ id: trackingId }} />,
}) => {
  const [content] = useState<React.ReactNode>(getContent(children, animateOnHover));
  const ElementType = element.type;

  return (() => (
    <ElementType {...element.props} className={clsx(styles.button, animateOnHover && styles.animateOnHover, className)}>
      {animateOnHover ? (
        <>
          <div className={styles.innerTop}>{content}</div>
          <div className={styles.innerBottom}>{content}</div>
        </>
      ) : (
        content
      )}
    </ElementType>
  ))();
};
